import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import './Auth.css';
import background from "../../assets/caja.webp";
import bajabox from "../../assets/logo.png";
import icons from "../../layout/Icons";

const Login: React.FC = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      console.log('Intentando login con:', { username: formData.username });
      const success = await login(formData.username, formData.password);
      console.log('Resultado del login:', success);
      
      if (success) {
        console.log('Login exitoso, navegando a documentación');
        navigate('/documentation');
      } else {
        console.log('Login falló - credenciales inválidas');
        setError('Usuario o contraseña incorrectos');
      }
    } catch (err: any) {
      console.error('Error en login:', err);
      
      // Manejar diferentes tipos de errores
      if (err.response?.status === 400) {
        setError(err.response.data?.error || 'Credenciales inválidas');
      } else if (err.response?.status === 500) {
        setError('Error del servidor. Intenta más tarde.');
      } else if (err.code === 'NETWORK_ERROR' || !err.response) {
        setError('Error de conexión. Verifica tu conexión a internet.');
      } else {
        setError('Error al iniciar sesión. Intenta nuevamente.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        {/* Panel izquierdo - Branding */}
        <div className="auth-left-panel">
          <div
            className="auth-left-background"
            style={{
              backgroundImage: `url(${background})`,
            }}
          ></div>
          <div className="auth-left-content">
            <div className="auth-brand-section">
              <div className="auth-brand-logo">
                <h1 className="auth-brand-title">
                  <span className="auth-brand-hash">#SOMOS</span>
                  <br />
                  <span className="auth-brand-baja">BAJA</span>
                  <br />
                  <span className="auth-brand-box">BOX</span>
                </h1>
              </div>
              <div className="auth-brand-buttons">
                <a href="https://bajaboxinventory.docsbbx.com/home" target="_blank" rel="noopener noreferrer" className="auth-brand-btn">Visitar página principal</a>
              </div>
            </div>
          </div>
        </div>

        {/* Panel derecho - Formulario */}
        <div className="auth-right-panel">
          <div className="auth-form-container">
            <div className="auth-form-header">
              <div className="auth-logo">
                <img src={bajabox} alt="BajaBox Logo" />
              </div>
              <h3 className="auth-form-subtitle">Bienvenido de vuelta</h3>
              <p className="auth-form-description">Ingresa para continuar</p>
            </div>

            <form onSubmit={handleSubmit} className="auth-form">
              {error && <div className="auth-error-message">{error}</div>}
              
              <div className="auth-form-group">
                <label htmlFor="username" className="auth-label">Nombre de Usuario</label>
                <input
                  type="text"
                  id="username"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  required
                  disabled={loading}
                  className="auth-input"
                  placeholder="Usuario"
                />
              </div>

              <div className="auth-form-group">
                <label htmlFor="password" className="auth-label">Contraseña</label>
                <div className="auth-password-container">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    disabled={loading}
                    className="auth-input"
                    placeholder="••••••••"
                  />
                  <button
                    type="button"
                    className="auth-password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? icons.EyeClose : icons.Eye}
                  </button>
                </div>
              </div>

              <button
                type="submit"
                className="auth-submit-btn"
                disabled={loading}
              >
                {loading ? 'Iniciando sesión...' : 'Iniciar sesión'}
              </button>
            </form>
          </div>

          {/* Footer en el panel derecho */}
          <div className="auth-right-footer">
            <p>
              © 2025 BajaBox. Todos los derechos reservados.
              <br />
              <a
                href="https://bajabox.com.mx/politica-de-privacidad/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Política de Privacidad
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;